import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import 'whatwg-fetch';
import { deleteEntity } from 'src/utils/entityApi';
import ModalConfirm from '../../components/modal/modalConfirm';
import Card from 'src/components/Card';
import { Typography } from '@material-ui/core';
import withAuth from 'src/hoc/withAuth';

class DashletLineChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: undefined,
      dashletInfo: undefined,
      dashletParsed: false,
      isModalDeleteDashletOpen: false,
      textModal: {
        title: 'Suppression Dashlet',
        message: 'Vous allez supprimer le dashlet',
      },
    };

    this.openModalDeleteDashlet = this.openModalDeleteDashlet.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    let dashlet = this.props.dashletInfo;

    if (dashlet && !this.state.dashletParsed) {
      if (typeof dashlet.metadata === 'string')
        //Necessary when you switch dashboard and return
        dashlet.metadata = JSON.parse(dashlet.metadata);
      this.setState({
        dashletInfo: dashlet,
        dashletParsed: true,
      });
    }
  }

  openModalDeleteDashlet() {
    this.props.toggleBlackOut();
    this.setState({
      isModalDeleteDashletOpen: true,
    });
  }
  closeModal() {
    this.setState({
      isModalDeleteDashletOpen: false,
    });
    this.props.toggleBlackOut();
  }

  postResult(type, promise) {
    promise.then(
      function (result) {
        if (result.wentFine) {
          this.props.openToast(true, 'Succès supression ' + type);
          this.props.onDelete();
        } else {
          this.props.openToast(false, 'Erreur suppression ' + type + '. Veuillez réessayer');
        }
      }.bind(this)
    );
  }

  render() {
    let data = [
      {
        id: 'japan',
        color: 'hsl(276, 70%, 50%)',
        data: [
          {
            x: 'plane',
            y: 173,
          },
          {
            x: 'helicopter',
            y: 46,
          },
          {
            x: 'boat',
            y: 143,
          },
          {
            x: 'train',
            y: 54,
          },
          {
            x: 'subway',
            y: 113,
          },
          {
            x: 'bus',
            y: 230,
          },
          {
            x: 'car',
            y: 221,
          },
          {
            x: 'moto',
            y: 268,
          },
          {
            x: 'bicycle',
            y: 161,
          },
          {
            x: 'horse',
            y: 298,
          },
          {
            x: 'skateboard',
            y: 107,
          },
          {
            x: 'others',
            y: 230,
          },
        ],
      },
      {
        id: 'france',
        color: 'hsl(150, 70%, 50%)',
        data: [
          {
            x: 'plane',
            y: 235,
          },
          {
            x: 'helicopter',
            y: 29,
          },
          {
            x: 'boat',
            y: 16,
          },
          {
            x: 'train',
            y: 16,
          },
          {
            x: 'subway',
            y: 137,
          },
          {
            x: 'bus',
            y: 238,
          },
          {
            x: 'car',
            y: 199,
          },
          {
            x: 'moto',
            y: 6,
          },
          {
            x: 'bicycle',
            y: 80,
          },
          {
            x: 'horse',
            y: 65,
          },
          {
            x: 'skateboard',
            y: 76,
          },
          {
            x: 'others',
            y: 258,
          },
        ],
      },
      {
        id: 'us',
        color: 'hsl(92, 70%, 50%)',
        data: [
          {
            x: 'plane',
            y: 164,
          },
          {
            x: 'helicopter',
            y: 273,
          },
          {
            x: 'boat',
            y: 61,
          },
          {
            x: 'train',
            y: 137,
          },
          {
            x: 'subway',
            y: 2,
          },
          {
            x: 'bus',
            y: 233,
          },
          {
            x: 'car',
            y: 60,
          },
          {
            x: 'moto',
            y: 16,
          },
          {
            x: 'bicycle',
            y: 87,
          },
          {
            x: 'horse',
            y: 260,
          },
          {
            x: 'skateboard',
            y: 39,
          },
          {
            x: 'others',
            y: 14,
          },
        ],
      },
      {
        id: 'germany',
        color: 'hsl(210, 70%, 50%)',
        data: [
          {
            x: 'plane',
            y: 13,
          },
          {
            x: 'helicopter',
            y: 171,
          },
          {
            x: 'boat',
            y: 132,
          },
          {
            x: 'train',
            y: 80,
          },
          {
            x: 'subway',
            y: 201,
          },
          {
            x: 'bus',
            y: 66,
          },
          {
            x: 'car',
            y: 223,
          },
          {
            x: 'moto',
            y: 41,
          },
          {
            x: 'bicycle',
            y: 196,
          },
          {
            x: 'horse',
            y: 227,
          },
          {
            x: 'skateboard',
            y: 157,
          },
          {
            x: 'others',
            y: 12,
          },
        ],
      },
      {
        id: 'norway',
        color: 'hsl(83, 70%, 50%)',
        data: [
          {
            x: 'plane',
            y: 199,
          },
          {
            x: 'helicopter',
            y: 26,
          },
          {
            x: 'boat',
            y: 260,
          },
          {
            x: 'train',
            y: 111,
          },
          {
            x: 'subway',
            y: 12,
          },
          {
            x: 'bus',
            y: 181,
          },
          {
            x: 'car',
            y: 172,
          },
          {
            x: 'moto',
            y: 196,
          },
          {
            x: 'bicycle',
            y: 53,
          },
          {
            x: 'horse',
            y: 85,
          },
          {
            x: 'skateboard',
            y: 102,
          },
          {
            x: 'others',
            y: 39,
          },
        ],
      },
    ];
    const MyResponsiveLine = ({ data /* see data tab */ }) => (
      <ResponsiveLine
        data={data}
        margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
        xScale={{ type: 'point' }}
        yScale={{ type: 'linear', stacked: true, min: 'auto', max: 'auto' }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          orient: 'bottom',
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'transportation',
          legendOffset: 36,
          legendPosition: 'middle',
        }}
        axisLeft={{
          orient: 'left',
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'count',
          legendOffset: -40,
          legendPosition: 'middle',
        }}
        colors={{ scheme: 'nivo' }}
        pointSize={10}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        pointLabel='y'
        pointLabelYOffset={-12}
        useMesh={true}
        legends={[
          {
            anchor: 'bottom-right',
            direction: 'column',
            justify: false,
            translateX: 100,
            translateY: 0,
            itemsSpacing: 0,
            itemDirection: 'left-to-right',
            itemWidth: 80,
            itemHeight: 20,
            itemOpacity: 0.75,
            symbolSize: 12,
            symbolShape: 'circle',
            symbolBorderColor: 'rgba(0, 0, 0, .5)',
            effects: [
              {
                on: 'hover',
                style: {
                  itemBackground: 'rgba(0, 0, 0, .03)',
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
      />
    );
    return (
      <Card style={{ display: 'block' }} className='dashlet'>
        <Typography variant='h6'>{this.state.dashletInfo ? this.state.dashletInfo.title : 'Chargement'}</Typography>

        {this.state.dashletInfo && (
          <button
            onClick={this.openModalDeleteDashlet}
            type='button'
            className='close dashlet-close'
            aria-label='Close'
          >
            <span aria-hidden='true'>&times;</span>
          </button>
        )}

        <div className='dashlet-content'>{<MyResponsiveLine data={data} />}</div>
        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteDashletOpen}
          onSubmit={(type, promise) =>
            this.postResult('dashlet', deleteEntity(this.props.authFetch, 'dashlet', this.state.dashletInfo.id))
          }
          onCancel={this.closeModal}
          onClose={this.closeModal}
        />
      </Card>
    );
  }
}

export default withAuth(DashletLineChart);
